import { I18nLocale } from "constants/enum";

export const DEFAULT_LOCALE = "default";

export const FALLBACK_LOCALE = I18nLocale.SPAIN_ES;
